import React from "react";
import { gsap } from "gsap";

type SidebarProps = {
  children: React.ReactNode;
  open: boolean;
  onClose?: () => void;
  className?: string;
};

const Sidebar = React.forwardRef(
  (
    { children, open, onClose, className }: SidebarProps,
    ref: React.ForwardedRef<HTMLDivElement>,
  ) => {
    const sidebarRef = React.useRef<HTMLDivElement>(null);

    const animateOpen = () => {
      gsap.to(sidebarRef.current, {
        duration: 0.3,
        x: 0,
        scale: 1,
        opacity: 1,
      });
    };

    const animateClose = () => {
      gsap.to(sidebarRef.current, {
        duration: 0.3,
        x: "100%",
        onComplete: onClose,
      });
    };

    React.useEffect(() => {
      if (typeof window !== "undefined") {
        gsap.set(sidebarRef.current, { x: "100%" });
        if (open) {
          animateOpen();
        } else {
          animateClose();
        }
      }
    }, [open]);

    return (
      <>
        <div
          ref={ref}
          onClick={onClose && animateClose}
          className={`sidebar-cart fixed right-0 top-0 z-[9999999] !mx-0 !mb-0 !mt-0 h-full w-full ${
            open
              ? "translate-x-0 transform transition-transform duration-300 ease-out"
              : "translate-x-full transform transition-transform duration-300 ease-out"
          } ${className}`}
        >
          <div ref={sidebarRef} className="h-full overflow-y-auto">
            {children}
          </div>
        </div>
      </>
    );
  },
);

Sidebar.displayName = "SidebarCart";

export default Sidebar;
